import { ScrapedBrandFilters } from "@/types/scraped-brand";

export const SCRAPED_BRAND_KEY = "SCRAPED_BRAND";

export const SCRAPED_BRAND_CACHE_KEY = {
  LIST: (filters: ScrapedBrandFilters) =>
    [SCRAPED_BRAND_KEY, "LIST", filters] as const,
};
